export const UPDATE_EDOK_FORM_SUCCESS = 'UPDATE_EDOK_FORM_SUCCESS';

export const updateEdokFormSuccess = ({ form }) => ({
    type: UPDATE_EDOK_FORM_SUCCESS,
    payload: {
        form,
    },
});
